import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChild,
    ViewChildren,
    ViewEncapsulation,
} from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { fuseAnimations } from "@fuse/animations";
import { MatTableDataSource } from "@angular/material/table";
import { StorageService } from "../../../common/service/storage.service";
import { FormBuilder, FormControl } from "@angular/forms";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Cassette } from "../cassette";
import { StatusService } from "../../status/status.service";
import * as moment from "moment";
import { CassetteListService } from "./cassette-list.service";
import { ConfigService } from "../../../common/config/config.service";
import { Globals } from "../../../common/global";
// import {BaseComponent} from '../../base/base.component';
import { MatSnackBar } from "@angular/material/snack-bar";
import { BaseListComponent } from "../../../base/base-list.component";
const timeZone = require("moment-timezone");
import { Subscription } from "rxjs";
import { CassetteInfiniteScroll } from "./cassette-infinite-scroll.service";
import { ApiService } from "app/main/module/common/service/api.service";
import { CassetteConfig } from "app/main/module/common/config/cassetteConfig";
import { DialogUtil } from "app/main/util/DialogUtil";
import { MatDialog } from "@angular/material/dialog";
import { element } from "protractor";
import { TranslateService } from "@ngx-translate/core";
import { TextUtils } from "app/main/util/TextUtils";
// import { CassetteConfig } from 'app/main/module/common/config/cassetteConfig';

@Component({
    selector: "cassette-table",
    templateUrl: "cassette.component.html",
    styleUrls: ["cassette.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class CassetteComponent implements OnInit, OnDestroy, AfterViewInit {
    columns: any[] = [];
    titleMatIcon = this.getTitleMatIcon();
    title = this.getTitle();
    displayedColumns = [];
    @ViewChild("filter", { static: true })
    filter: ElementRef;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;
    cassette: string;
    perPageData = this.globals.perPageData;
    protected extraCta = {
        visibility: false,
        text: "",
    };

    disableUnassign = true;
    // @ViewChild(MatPaginator, {static: true})
    // paginator: MatPaginator;
    isInitComplete = true;
    isLoading = false;
    isNextPressed = false;
    todayDate: Date = new Date();
    isMoreDataAvailable = true;
    prev: number;
    next: number;
    count: number;
    totalPage: boolean;
    allData: Array<any>;
    errorMessage: any;
    loadedcassetteData: Cassette[] = [];
    cassetteConfigData: CassetteConfig[] = [];
    dataSource = new MatTableDataSource<any>(this.loadedcassetteData);
    dataSourceFilters = new MatTableDataSource(this.loadedcassetteData);
    dataSourceWithPageSize = new MatTableDataSource(this.loadedcassetteData);
    page: number;
    canShowAlertIfIncubatorPending: unknown;
    assignedBy: any;
    assignedOn: any;
    status: string;
    isassigndonefinal: any;
    can_assign_if_incubator_pending: any;
    isLoginFailed: boolean;
    searchText: any;
    result: string;
    isEnterPressed: boolean;
    selectedStatus: string;
    filteredCassette: Array<any>;
    statusMessages = [
        CassetteStatus.AVAILABLE,
        CassetteStatus.Failed,
        CassetteStatus.IN_PROGRESS,
        CassetteStatus.IN_PROGRESS_BI_PENDING,
        CassetteStatus.PATIENTUSED,
        CassetteStatus.PATIENTUSED_FAILED,
        CassetteStatus.PATIENTUSED_IN_PROGRESS,
        CassetteStatus.RESET,
    ];
    translatedStatusMessages = [];
    enableAssign = false;
    inProgressStatus: string;
    detailPagePath = "viewcassettedetails";
    currentPagePath = "/cassette/cassette";
    routerSubscription: Subscription;
    hide_result_pending_confirmation: any;
    hasMoreData: boolean = true;
    PAGE_SIZE: number = 10;
    private observer: MutationObserver | null = null;
    overflowFlags: boolean[] = [];
    @ViewChildren("cellContent") cellContents!: QueryList<ElementRef>;
    isSpoiled: boolean = false;
    searchDisabled: boolean = false;
    isDataLoaded: boolean = true;

    constructor(
        private userSevice: StorageService,
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private paginationService: CassetteListService,
        private infiniteScroll: CassetteInfiniteScroll,
        private changeDetectorRefs: ChangeDetectorRef,
        private statusService: StatusService,
        public snackBar: MatSnackBar,
        private configService: ConfigService,
        private apiService: ApiService,
        private globals: Globals,
        public dialog: MatDialog,
        public translate: TranslateService,
        private el: ElementRef,
        private cdr: ChangeDetectorRef,
    ) {
        // super(snackBar, configService, globals);
        this.selectedStatus = localStorage.getItem("selectedStatus") || "all";
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        const lab_id = this.userSevice.getCookie("lab_id");
        this.hide_result_pending_confirmation = localStorage.getItem(
            "hide_result_pending_confirmation",
        );

        this.translate
            .get(this.statusMessages.map((status) => `Status.${status}`))
            .subscribe((res) => {
                this.translatedStatusMessages = this.statusMessages.map(
                    (status) => ({
                        label: res[`Status.${status}`] || status, // French label or fallback
                        value: status, // English value (Enum string)
                    }),
                );
            });

        const keys = [
            "Common.Sr",
            "Common.Sterilizer",
            "Common.Type",
            "Common.Program",
            "Common.CycleNo",
            "Common.Barcode",
            "Common.BD",
            "Common.BI",
            "Common.EI",
            "Common.User",
            "Common.DateTime",
            "Common.Status",
            "Common.Details",
            "Cassettes.Result",
            "Cassettes.Checkout",
        ];
        this.translate.onLangChange.subscribe(() => {
            this.translate.get(keys).subscribe((translations) => {
                this.columns = this.getColumn(translations);
                this.displayedColumns = this.columns.map((c) => c.columnDef);
            });
        });

        this.translate.get(keys).subscribe((translations) => {
            this.columns = this.getColumn(translations);
            this.displayedColumns = this.columns.map((c) => c.columnDef);
        });

        if (lab_id) {
            this.isInitComplete = true;
            this.dataSource.data = [];
            this.loadedcassetteData = [];
            this.getCassetteConfig();
            this.isLoading = true;
            this.prev = 0;
            this.next = 1;
            this.page = 0;
            this.count = 1;
            this.filteredCassetteData(1);
            this.routerSubscription = this.router.events.subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    if (
                        !event.url.includes(this.detailPagePath) &&
                        !event.url.includes(this.currentPagePath)
                    ) {
                        localStorage.removeItem("selectedStatus");
                    }
                }
            });
            this.selectedStatus =
                localStorage.getItem("selectedStatus") || "all";
        } else {
            this.logout();
        }
        // console.log(this.selectedStatus);
    }

    getAllData(page) {
        this.isInitComplete = true;
        this.totalPage = false;
        this.paginationService.getAllCassetteData(page, true).subscribe(
            (a) => {
                Object.entries(a).find(([key, value]) => {
                    if (key == "message" && value == "No data Found") {
                        this.totalPage = true;
                        this.searchDisabled = false;
                        this.isDataLoaded = true;
                    }

                    if (key == "data") {
                        this.isInitComplete = false;
                        this.allData = value;
                        this.searchDisabled = false;
                        this.isDataLoaded = true;

                        this.hasMoreData =
                            this.allData.length === this.PAGE_SIZE;
                        if (!this.hasMoreData && this.isNextPressed) {
                            this.openSnackBar(
                                this.translateSentence(
                                    "Common.noFurtherDataAvailable",
                                ),
                                this.translateSentence("Common.ok"),
                            );
                        }

                        this.isassigndonefinal = "";
                        this.allData.forEach((element) => {
                            this.isLoading = false;

                            // console.log(element);

                            const cass: Cassette = element;

                            this.result = this.getCassetteResult(element);
                            // // console.log(t);
                            if (element.cassette_status == "Assigned") {
                                if (this.result == "Pending") {
                                    this.status = "Used(P)";
                                } else {
                                    this.status = "Used";
                                }
                            } else if (element.cassette_status == "Used") {
                                if (this.result == "Pending") {
                                    this.status = "Used(P)";
                                } else {
                                    this.status = "Used";
                                }
                            } else if (
                                element.cassette_status != "Used" &&
                                element.cassette_status != "Assigned" &&
                                element.cassette_status != "Spoiled"
                            ) {
                                this.status = this.getLoadStatus(element);
                            } else if (element.cassette_status == "Spoiled") {
                                this.status = "Spoiled";
                            }

                            this.isSpoiled = element.is_spoiled;

                            this.loadedcassetteData.push({
                                assigned_to_department:
                                    element.assigned_to_department,
                                barcode: element.barcode,
                                added: element.added_by,
                                startedBy: element.created_by,
                                assigned: element.assigned_by,
                                updated: element.updated_by,
                                spoiled: element.spoiled_by,
                                comment: "",
                                receiverName: "",
                                departmentName: "",
                                department: undefined,
                                print_title: element.print_title,
                                barcodeBd: element.bd_barcode,
                                barcodeBi: element.bi_barcode,
                                barcodeEi: element.ei_barcode,
                                machineName: "",
                                status: this.status,
                                bd_status: element.bd_status,
                                bi_status: element.bi_status,
                                ei_status: element.ei_status,
                                isAssignDone: element.is_assigned_to_patient,
                                unassigned_by: element.unassigned_by,
                                isSpoiled: element.is_spoiled,
                                type: element.cassette_type,
                                version: 0,
                                cycleNo: element.cycle_number,
                                loadNo: element.load_number,
                                program: element.cassette_program,
                                dateTimeNum: element.timestamp,
                                loadIdStr: "",
                                machineIdStr: "",
                                plateform: "",
                                platform: this.result,
                                verified: "",
                                createdUser: "",
                                patientId: "",
                                patientName: "",
                                cassetteID: "",
                                updatedBy: "",
                                time: "",
                                date: element.timestamp,
                                id: "",
                                docId: "",
                            });
                        });
                    } else {
                        // // // console.log(e);
                    }
                });
                //  // // console.log(a);

                // this.loadedcassetteData.sort((a, b) =>
                //     a.status.localeCompare(b.status)
                // );
                this.dataSource.data = this.loadedcassetteData;
                //  // // console.log(a);
            },

            (err) => {
                this.errorMessage = err.error.message;
                this.searchDisabled = false;
                this.isDataLoaded = true;
                // // console.log(e);
                if (err.status == 401) {
                    alert(this.translateSentence("Login.InvalidToken"));
                    this.logout();
                }
            },
        );
    }
    logout(): void {
        const keep = new Set(["language"]);
        Object.keys(localStorage).forEach((key) => {
            if (!keep.has(key)) {
                // console.log(`Removing key: ${key}`);
                localStorage.removeItem(key);
            }
        });
        this.router.navigate(["/login"]);
        // location.reload();
    }

    changeDate(date): any {
        // // // console.log(e);
        var timestamp = parseInt(date);
        return (date = this.apiService.getDateStringMomentByTz(timestamp));
    }

    scrollToBottom(): void {
        if (this.isNextPressed) {
            this.isNextPressed = false;
            const table = document.querySelector("mat-table");
            table.scrollBy({
                behavior: "smooth",
                left: 0,
                top: table.scrollHeight,
            });
        }
    }

    ngAfterViewChecked() {
        // your code to update the model
        // this.changeDetectorRefs.detectChanges();
    }
    isOrderByNegative(): boolean {
        return true;
    }

    getRowBackgroundColor(element): string {
        return "#FFFFFF";
    }

    canAssign(cassette): boolean {
        if (this.statusService.canAssign(cassette)) {
            return cassette.barcode;
        }
    }

    onNextPress() {
        this.isLoading = true;
        this.isNextPressed = true;
        this.count = this.count + 1;
        this.next = this.prev + 1;
        this.prev = this.next - 1;
        this.next++;
        this.prev++;
        this.filteredCassetteData(this.next);
        // // console.log(v);
    }

    getColumn(translations: { [key: string]: string }): any[] {
        return [
            {
                columnDef: "SrCassette",
                header: translations["Common.Sr"],
                cell: (element: Cassette, index: number) =>
                    `${this.page * 10 + index + 1}`,
            },
            {
                columnDef: "BarcodeCassette",
                header: translations["Common.Barcode"],
                cell: (element: Cassette, index: number) =>
                    `${element.barcode}`,
                textColor: (element: Cassette, index: number) =>
                    `${this.getBarcodeColor(element)}`,
            },
            {
                columnDef: "type2",
                header: translations["Common.Type"],
                cell: (element: Cassette, index: number) =>
                    `${element.type ? element.type : "-"}`,
            },
            // { columnDef: 'Load No', header: 'Load No', cell: (element: Cassette, index: number) => `${element.loadNo}` },
            {
                columnDef: "Cycle No",
                header: translations["Common.CycleNo"],
                cell: (element: Cassette, index: number) =>
                    `${element.cycleNo}`,
            },
            {
                columnDef: "ResultCassette",
                header: translations["Cassettes.Result"],
                cell: (element: Cassette, index: number) => {
                    const result = element.platform;
                    const translationKey = `Result.${result}`;
                    return this.translateSentence(translationKey);
                },
                textColor: (element: Cassette, index: number) =>
                    `${this.getLoadColor(element)}`,
            },
            {
                columnDef: "Date",
                header: translations["Common.DateTime"],
                cell: (element: Cassette, index: number) =>
                    `${this.changeDate(element.dateTimeNum)}`,
            },
            // { columnDef: 'timeCassette', header: 'Time', cell: (element: Cassette, index: number) => `${element.time}` },
            {
                columnDef: "BD",
                header: translations["Common.BD"],
                cell: (element: Cassette, index: number) =>
                    `${element.barcodeBd ? element.barcodeBd : "-"}`,
                textColor: (element: Cassette, index: number) =>
                    `${this.getSingleLoadColor(element.bd_status)}`,
            },
            {
                columnDef: "BI",
                header: translations["Common.BI"],
                cell: (element: Cassette, index: number) =>
                    `${element.barcodeBi ? element.barcodeBi : "-"}`,
                textColor: (element: Cassette, index: number) =>
                    `${this.getSingleLoadColor(element.bi_status)}`,
            },
            {
                columnDef: "EI",
                header: translations["Common.EI"],
                cell: (element: Cassette, index: number) =>
                    `${element.barcodeEi ? element.barcodeEi : ""}`,
                textColor: (element: Cassette, index: number) =>
                    `${this.getSingleLoadColor(element.ei_status)}`,
            },
            {
                columnDef: "StatusCassette",
                header: translations["Common.Status"],
                cell: (element: Cassette, index: number) => {
                    const status = this.getLoadStatus(element);
                    const translationKey = `Status.${status}`;
                    return this.translateSentence(translationKey);
                },
            },
            {
                columnDef: "CassetteMdetails",
                header: translations["Common.Details"],
                cell: (element: Cassette, index: number) =>
                    this.loadStatusUsed(
                        this.getLoadStatus(element),
                        element.barcode,
                    ),
            },
            {
                columnDef: "actionCassette",
                header: translations["Cassettes.Checkout"],
                cell: (element: Cassette, index: number) =>
                    `${(this.canAssign(element), element.barcode)}`,
            },
            // {
            //     columnDef: 'unassign', header: 'UnAssign',
            //     cell: (element: Cassette, index: number) => this.loadStatusUnassign(this.getLoadStatus(element), element.id)
            // },
        ];
    }

    filteredCassetteData(page) {
        this.isInitComplete = true;
        this.totalPage = false;
        // console.log("selected: ", this.selectedStatus);

        this.paginationService
            .getFilterCassetteByStatus(this.selectedStatus, page)
            .subscribe(
                (res) => {
                    Object.entries(res).find(([key, value]) => {
                        if (key == "message" && value == "No data Found") {
                            this.totalPage = true;
                        }
                        if (key == "data" && value != "") {
                            this.isInitComplete = false;
                            this.searchDisabled = false;
                            this.isDataLoaded = true;
                            this.filteredCassette = value;
                            this.hasMoreData =
                                this.filteredCassette.length === this.PAGE_SIZE;
                            if (!this.hasMoreData && this.isNextPressed) {
                                this.openSnackBar(
                                    this.translateSentence(
                                        "Common.noFurtherDataAvailable",
                                    ),
                                    this.translateSentence("Common.ok"),
                                );
                            }

                            this.filteredCassette.forEach((element) => {
                                this.isLoading = false;
                                const cass: Cassette = element;
                                this.result = this.getCassetteResult(element);
                                if (element.cassette_status == "Assigned") {
                                    if (this.result == "Pending") {
                                        this.status = "Used(P)";
                                    } else {
                                        this.status = "Used";
                                    }
                                } else if (element.cassette_status == "Used") {
                                    if (this.result == "Pending") {
                                        this.status = "Used(P)";
                                    } else {
                                        this.status = "Used";
                                    }
                                } else if (
                                    element.cassette_status != "Used" &&
                                    element.cassette_status != "Assigned" &&
                                    element.cassette_status != "Spoiled"
                                ) {
                                    this.status = this.getLoadStatus(element);
                                } else if (
                                    element.cassette_status == "Spoiled"
                                ) {
                                    this.status = "Spoiled";
                                } else if (
                                    element.cassette_status ==
                                        "Incubator_Failed" &&
                                    element.is_assigned_to_patient === true
                                ) {
                                    this.status = "Used(F)";
                                }
                                this.loadedcassetteData.push({
                                    assigned_to_department:
                                        element.assigned_to_department,
                                    barcode: element.barcode,
                                    added: element.added_by,
                                    startedBy: element.created_by,
                                    assigned: element.assigned_by,
                                    updated: element.updated_by,
                                    spoiled: element.spoiled_by,
                                    comment: "",
                                    receiverName: "",
                                    departmentName: "",
                                    department: undefined,
                                    print_title: element.print_title,
                                    barcodeBd: element.bd_barcode,
                                    barcodeBi: element.bi_barcode,
                                    barcodeEi: element.ei_barcode,
                                    machineName: "",
                                    status: this.status,
                                    bd_status: element.bd_status,
                                    bi_status: element.bi_status,
                                    ei_status: element.ei_status,
                                    isAssignDone:
                                        element.is_assigned_to_patient,
                                    unassigned_by: element.unassigned_by,
                                    isSpoiled: element.is_spoiled,
                                    type: element.cassette_type,
                                    version: 0,
                                    cycleNo: element.cycle_number,
                                    loadNo: element.load_number,
                                    program: element.cassette_program,
                                    dateTimeNum: element.timestamp,
                                    loadIdStr: "",
                                    machineIdStr: "",
                                    plateform: "",
                                    platform: this.result,
                                    verified: "",
                                    createdUser: "",
                                    patientId: "",
                                    patientName: "",
                                    cassetteID: "",
                                    updatedBy: "",
                                    time: "",
                                    date: element.timestamp,
                                    id: "",
                                    docId: "",
                                });
                            });
                            this.dataSource.data = this.loadedcassetteData;
                        } else {
                            //@ts-ignore
                            if (res.data.length === 0) {
                                this.isInitComplete = false;
                                this.isLoading = false;
                                this.searchDisabled = false;
                                this.isDataLoaded = true;

                                //@ts-ignore
                                this.openSnackBar(
                                    this.translateSentence(
                                        "Common.noDataFound",
                                    ),
                                    this.translateSentence("Common.ok"),
                                );
                            }
                        }
                    });
                },
                (err) => {
                    this.searchDisabled = false;
                    this.isDataLoaded = true;
                    this.openSnackBar(err.message, "Ok");
                },
            );
    }

    filterCassetteByStatus() {
        this.dataSource.data = [];
        this.loadedcassetteData = [];
        this.next = 1;
        this.page = 0;
        this.prev = 0;
        this.searchText = "";
        localStorage.setItem("selectedStatus", this.selectedStatus);
        this.filteredCassetteData(this.next);
    }

    getCassetteConfig() {
        this.apiService.getCassetteconfigdata().subscribe((a) => {
            // // console.log(a);
            Object.entries(a).find(([key, value]) => {
                if (key == "data") {
                    value.forEach((element) => {
                        this.can_assign_if_incubator_pending =
                            element.cassette.can_assign_if_incubator_pending;
                        Object.entries(element.cassette).find(
                            ([key, value]) => {},
                        );
                    });
                }
            });
        });
    }
    getCassetteType(element) {
        // // console.log(e);
        if (element.print_title != undefined && element.type != undefined) {
            if (element.type == "Implant") {
                return "I-" + element.print_title;
            } else {
                return element.print_title;
            }
        } else if (element.print_title == "" && element.type == "") {
            return "-";
        }
        //     if(element.print_title != undefined && element.type != undefined){
        //     if(element.type == 'Implant'){
        //         return 'I-' + element.print_title
        //     }
        //     else{
        //         return element.print_title
        //     }
        // }else{
        //     return '-'
        // }
    }

    getBarcodeColor(element) {
        if (element.verified == true) {
            return this.statusService.getBarcodeColor(element.barcode);
            //     // // console.log(d);
            //     if(element.verified == true){
            //     return '##0000FF';
        }
        // else{
        //     return '#000000'
        // }
    }

    loadStatusAvailable(functValue, barcode) {
        if (functValue === "Availbale") {
            return barcode;
        }
    }
    loadStatusUsed(functValue, id) {
        // if(functValue === 'USED'
        // // // console.log(d);
        return id;
        // }
    }
    loadStatusUnassign(functValue, id) {
        if (
            functValue === "USED" ||
            functValue === "Used" ||
            functValue === "Used(P)"
        ) {
            return id;
        }
    }

    getLoadStatus(load: Cassette): string {
        // // // console.log(d);
        return this.statusService.getCassetteStatus(load);
    }

    getCassetteResult(load: Cassette): string {
        return this.statusService.getMessage(
            this.statusService.getStatusNew(
                load.bd_status,
                load.bi_status,
                load.ei_status,
            ),
        );
    }

    getLoadColor(load: Cassette): string {
        return this.statusService.getColor(
            this.statusService.getStatusNew(
                load.bd_status,
                load.bi_status,
                load.ei_status,
            ),
        );
    }

    getSingleLoadColor(load: string): string {
        if (load) {
            return this.statusService.getColor(
                this.statusService.getStatus(load),
            );
        } else {
            return "#111111";
        }
    }

    // updateRow(row): any {
    //     row.date = moment(Math.abs(row.dateTimeNum)).format('DD-MM-YYYY');
    //     row.time = moment(Math.abs(row.dateTimeNum)).format('HH:mm');
    // }

    updateRow(row): any {
        row.date = timeZone(Math.abs(row.dateTimeNum))
            .tz(this.userSevice.getCookie("defaultTz"))
            .format("DD-MM-YYYY");
        row.time = timeZone(Math.abs(row.dateTimeNum))
            .tz(this.userSevice.getCookie("defaultTz"))
            .format("HH:mm");
        // row.time = moment(Math.abs(row.dateTimeNum)).format('HH:mm');
    }

    getTitleMatIcon(): string {
        return "ballot";
    }

    getTitle(): string {
        return "Cassettes";
    }

    getSearchText(): string {
        return "Scan/Enter Barcode ";
    }

    assignCassette(barcode, status) {
        // console.log(this.inProgressStatus);

        this.status = status;

        // console.log(this.status);

        if (this.hide_result_pending_confirmation === "true") {
            this.router.navigate(["/assign"], {
                queryParams: { barcode: barcode.trim() },
            });
        } else {
            if (this.status === "In Progress(P)") {
                const dialogUtil = new DialogUtil();
                dialogUtil.openConfirmationDialog(
                    this.dialog,
                    `${this.translateSentence(
                        "Cassettes.IncubatorPendingMessage",
                    )} ${barcode}?`,
                    {
                        onConfirm: () => {
                            this.router.navigate(["/assign"], {
                                queryParams: { barcode: barcode.trim() },
                            });
                        },
                        onCancel: () => {
                            this.enableAssign = false;
                        },
                        onAlways: () => {},
                    },
                );
            } else {
                this.router.navigate(["/assign"], {
                    queryParams: { barcode: barcode.trim() },
                });
            }
        }
    }
    viewCassette(barcode) {
        this.router.navigate(["/viewcassettedetails"], {
            queryParams: { barcode: barcode },
        });
    }

    // protected getPaginationService() {
    //     return this.paginationService;
    // }
    // @HostListener('document:keypress', ['$event'])
    // handleKeyboardEvent(event: KeyboardEvent) {
    //     this.handleEnterSearch(event);
    // }
    // changeCheckboxEvent(event, row){

    //     if(event.cheked === true){
    //         this.unassignList.push(row);
    //         // // console.log(t);
    //     }else{
    //         this.unassignList = this.unassignList.filter(element => element !== row);
    //         // // console.log(t);
    //     }
    // }

    nextPage(): void {
        // this.isLoading = true;
        // this.isNextPressed = true;
        // this.infiniteScroll.more();
    }

    ngAfterViewInit(): void {
        const table: HTMLElement | null =
            this.el.nativeElement.querySelector("mat-table");
        if (!table) return;

        this.observer = new MutationObserver((mutations) => {
            if (!this.isNextPressed) return;

            const rows = table.querySelectorAll(".mat-row");
            if (rows.length > 0) {
                const last = rows[rows.length - 1] as HTMLElement;
                last.scrollIntoView({ behavior: "smooth", block: "end" });
                this.isNextPressed = false;
            }
        });

        this.observer.observe(table, { childList: true, subtree: true });
        this.updateOverflowFlags();

        this.cellContents.changes.subscribe(() => this.updateOverflowFlags());
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private updateOverflowFlags(): void {
        this.overflowFlags = this.cellContents.map((el) =>
            this.isTextOverflowing(el.nativeElement),
        );
        this.cdr.detectChanges();
    }

    // need to uncomment and implement

    onClickSearch(searchText) {
        this.selectedStatus = "all";
        localStorage.setItem("selectedStatus", this.selectedStatus);
        if (!searchText || !searchText.trim()) {
            this.openSnackBar(
                this.translateSentence("Common.noSearchValueAvailable"),
                this.translateSentence("Common.ok"),
            );
        } else {
            this.loadedcassetteData = [];
            this.dataSource.data = [];
            this.allData = [];
            this.totalPage = true;
            this.isInitComplete = true;
            this.isLoading = true;
            this.searchDisabled = true;
            this.isDataLoaded = false;
            this.searchText = searchText.replace(/[^a-zA-Z0-9 ]/g, "").trim();
            this.paginationService.searchCasset(this.searchText).subscribe(
                (a) => {
                    // // console.log(a);
                    Object.entries(a).find(([key, value]) => {
                        if (key == "data") {
                            this.isInitComplete = false;
                            this.allData = value;
                            this.searchDisabled = false;
                            this.isDataLoaded = true;
                            // // console.log(a);
                            this.isassigndonefinal = "";
                            this.allData.forEach((element) => {
                                //  // // console.log(e);
                                this.isLoading = false;
                                this.result = this.getCassetteResult(element);

                                const cass: Cassette = element;

                                if (element.department_assigned_by) {
                                    this.assignedBy =
                                        element.department_assigned_by.name;
                                    // this.assignedOn = this.updateDate(element.department_assigned_by.timestamp);
                                    cass.isAssignDone =
                                        element.department_assigned_by.name;
                                    this.isassigndonefinal = cass.isAssignDone;
                                }
                                if (element.cassette_status == "Assigned") {
                                    if (this.result == "Pending") {
                                        this.status = "Used(P)";
                                    } else {
                                        this.status = "Used";
                                    }
                                } else if (element.cassette_status == "Used") {
                                    if (this.result == "Pending") {
                                        this.status = "Used(P)";
                                    } else {
                                        this.status = "Used";
                                    }
                                } else if (
                                    element.cassette_status != "Used" &&
                                    element.cassette_status != "Assigned" &&
                                    element.cassette_status != "Spoiled"
                                ) {
                                    this.status = this.getLoadStatus(element);
                                } else if (
                                    element.cassette_status == "Spoiled"
                                ) {
                                    this.status = "Spoiled";
                                }
                                this.loadedcassetteData.push({
                                    assigned_to_department:
                                        element.assigned_to_department,
                                    barcode: element.barcode,
                                    added: undefined,
                                    startedBy: undefined,
                                    assigned: undefined,
                                    updated: undefined,
                                    spoiled: undefined,
                                    comment: "",
                                    receiverName: "",
                                    departmentName: "",
                                    department: undefined,
                                    print_title: element.print_title,
                                    barcodeBd: element.bd_barcode,
                                    barcodeBi: element.bi_barcode,
                                    barcodeEi: element.ei_barcode,
                                    machineName: "",
                                    status: this.status,
                                    bd_status: element.bd_status,
                                    bi_status: element.bi_status,
                                    ei_status: element.ei_status,
                                    isAssignDone:
                                        element.is_assigned_to_patient,
                                    unassigned_by: element.unassigned_by,
                                    isSpoiled: element.is_spoiled,
                                    type: element.cassette_type,
                                    version: 0,
                                    cycleNo: element.cycle_number,
                                    loadNo: 0,
                                    program: "",
                                    dateTimeNum: element.timestamp,
                                    loadIdStr: "",
                                    machineIdStr: "",
                                    plateform: "",
                                    platform: this.result,
                                    verified: "",
                                    createdUser: "",
                                    patientId: "",
                                    patientName: "",
                                    cassetteID: "",
                                    updatedBy: "",
                                    time: "",
                                    date: element.timestamp,
                                    id: "",
                                    docId: "",
                                });
                            });
                        } else if (key == "status" && value == "failed") {
                            // else {
                            // // console.log(e);
                            this.isLoading = false;
                            this.searchDisabled = false;
                            this.isDataLoaded = true;
                            this.openSnackBar(
                                this.translateSentence("Common.noDataFound"),
                                this.translateSentence("Common.ok"),
                            );
                            // window.location.reload();
                        }
                    });
                    //  // // console.log(a);
                    this.dataSource.data = this.loadedcassetteData;
                    //  // // console.log(a);
                },
                (err) => {
                    this.errorMessage = err.error.message;
                    this.searchDisabled = false;
                    this.isDataLoaded = true;
                    // // console.log(e);
                    this.isLoginFailed = true;
                },
            );
        }
    }

    refreshSearch(event) {
        if (event.code === "Backspace" && this.searchText.length === 1) {
            this.searchText = "";
            this.searchDisabled = true;
            this.isDataLoaded = true;
            this.ngOnInit();
        }
    }
    openSnackBar(message: string, action: string): void {
        // this.isLoading = true;
        // this.hasFirstDataShown = true;
        this.snackBar.open(message, action, {
            duration: 1000,
        });
    }

    clearInputSearch() {
        this.searchText = "";
        this.searchDisabled = true;
        this.isDataLoaded = true;
        this.ngOnInit();
    }

    @HostListener("document:keypress", ["$event"])
    handleKeyboardEvent(event: KeyboardEvent) {
        this.handleEnterSearch(event);
    }

    handleEnterSearch(event: KeyboardEvent) {
        if (
            event.key.includes("Enter") &&
            event.code.includes("Enter") &&
            document.activeElement.id.includes("search")
        ) {
            this.isEnterPressed = true;
            if (this.searchText && this.searchText.length > 0) {
                this.onClickSearch(this.searchText);
            }
        } else {
            this.isEnterPressed = false;
        }
    }

    isTextOverflowing(element: HTMLElement): boolean {
        return element.scrollWidth > element.clientWidth;
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }
}
